import { Link } from "react-router-dom";

function Sitemap() {
  return (
    <div>
      {/* Hero section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Sitemap</h1>
          <p>
            Find your way around AirArrange. Below is a complete overview of all
            pages and resources available on our platform.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="max-w-5xl mx-auto px-6 py-16 space-y-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Main Pages */}
          <div>
            <h2 className="text-xl font-bold mb-4 text-gray-800">Main Pages</h2>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/workspaces"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Browse Workspaces
                </Link>
              </li>
              <li>
                <Link
                  to="/aboutUs"
                  className="text-[var(--secondary)] hover:underline"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h2 className="text-xl font-bold mb-4 text-gray-800">Support</h2>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/help"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Help Centre
                </Link>
              </li>
              <li>
                <Link
                  to="/contactUs"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/trust-and-safety"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Trust & Safety
                </Link>
              </li>
            </ul>
          </div>

          {/* Hosting */}
          <div>
            <h2 className="text-xl font-bold mb-4 text-gray-800">Hosting</h2>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/account?mode=host&section=addWorkspace"
                  className="text-[var(--secondary)] hover:underline"
                >
                  List Your Workspace
                </Link>
              </li>
              <li>
                <Link
                  to="/host-responsibilities"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Hosting Responsibly
                </Link>
              </li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h2 className="text-xl font-bold mb-4 text-gray-800">Account</h2>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/account"
                  className="text-[var(--secondary)] hover:underline"
                >
                  My Account
                </Link>
              </li>
              <li>
                <Link
                  to="/account?mode=user"
                  className="text-[var(--secondary)] hover:underline"
                >
                  My Bookings
                </Link>
              </li>
              <li>
                <Link
                  to="/account?mode=host"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Host Dashboard
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h2 className="text-xl font-bold mb-4 text-gray-800">Legal</h2>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-of-service"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/company-details"
                  className="text-[var(--secondary)] hover:underline"
                >
                  Company Details
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Additional Info */}
        <div className="border-t pt-8">
          <h2 className="text-2xl font-semibold mb-4">Need Help?</h2>
          <p className="text-gray-600 mb-4">
            Can't find what you're looking for? Our support team is here to
            help.
          </p>
          <Link to="/contactUs" className="secondary-button">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Sitemap;
